import { rootId, TaskListItemTypes, TaskListTreeItem } from '@griply/types';
import { ID } from 'shared/types/id';

import { LIFE_AREA_ARCHIVED_SECTION_ID } from './constants';
import { LifeAreaRowData } from './types';

const toLifeAreaItem = ({ id, name }: LifeAreaRowData): TaskListTreeItem => ({
  id,
  type: TaskListItemTypes.LifeArea,
  name,
  children: [],
});

export const buildLifeAreaTreeItems = (
  activeRows: LifeAreaRowData[],
  archivedRows: LifeAreaRowData[] = [],
): Record<ID, TaskListTreeItem> => {
  const rootChildren = activeRows.map(({ id }) => id);

  if (archivedRows.length) {
    rootChildren.push(LIFE_AREA_ARCHIVED_SECTION_ID);
  }

  const items: Record<ID, TaskListTreeItem> = {
    [rootId]: {
      id: rootId,
      type: TaskListItemTypes.Root,
      name: '',
      isFolder: true,
      children: rootChildren,
    },
  };

  activeRows.forEach((row) => {
    items[row.id] = toLifeAreaItem(row);
  });

  if (archivedRows.length) {
    items[LIFE_AREA_ARCHIVED_SECTION_ID] = {
      id: LIFE_AREA_ARCHIVED_SECTION_ID,
      type: TaskListItemTypes.Section,
      name: 'Archived',
      isFolder: true,
      children: archivedRows.map(({ id }) => id),
    };

    archivedRows.forEach((row) => {
      items[row.id] = toLifeAreaItem(row);
    });
  }

  return items;
};
